import RoundedButtonSecondaryAlt from '../../../components/button/rounded-button-secondary-alt/RoundedButtonSecondaryAlt';
import styles from './change-count-buttons.module.less';

export const ChangeCountButtons = ({ decreaseCount, increaseCount, count, minCount, maxCount }) => {
    return (
        <fieldset className={styles.footerButtons}>
            <div className={styles.selectNumberOfProducs}>
                <RoundedButtonSecondaryAlt
                    type="button"
                    onClick={decreaseCount}
                    disabled={count <= minCount}
                    className={styles.valueButton}
                    title={'Velg færre'}
                >
                    –
                </RoundedButtonSecondaryAlt>
                <div className={styles.selectedCount}>{count}</div>
                <RoundedButtonSecondaryAlt
                    type="button"
                    onClick={increaseCount}
                    className={styles.valueButton}
                    disabled={count >= maxCount}
                    title={'Velg flere'}
                >
                    +
                </RoundedButtonSecondaryAlt>
            </div>
        </fieldset>
    );
};
